import { API_URL, METHOD } from '../constants/network'
import { serialize } from '../utils'
import { fetchAPI } from '../utils/network'

export const getHearingLectures = (params) => {
    return fetchAPI({
        url: `${API_URL.HEARING_LECTURES}${serialize(params)}`,
        method: METHOD.GET,
    })
}

export const createHearingLecture = (body) => {
    return fetchAPI({
        url: API_URL.HEARING_LECTURES,
        method: METHOD.POST,
        body,
    })
}

export const updateHearingLecture = (id, body) => {
    return fetchAPI({
        url: `${API_URL.HEARING_LECTURES}/${id}`,
        method: METHOD.PUT,
        body,
    })
}

export const bulkUploadHearingLectures = (lectures) => {
    return fetchAPI({
        url: API_URL.HEARING_LECTURES_BULK,
        method: METHOD.POST,
        body: { lectures },
    })
}

export const bulkDeleteHearingLectures = (ids) => {
    return fetchAPI({
        url: API_URL.HEARING_LECTURES_BULK_DELETE,
        method: METHOD.POST,
        body: { ids },
    })
}

